module.exports = __webpack_public_path__ + "static/media/Eric-Alexandre.5804976c.jpg";